import React, { useCallback, useEffect } from "react";
import { FormHeader } from "@components/Header";
import { useNavigate, useSearchParams } from "react-router-dom";
import { FormBody, FormContentContainer } from "@components/Container";
import { BottomActionButton } from "@components/BottomActionArea";
import { BottomActionArea } from "@components/BottomActionArea";
import { Box, styled, Typography } from "@mui/material";
import { FullScreenLoader } from "@components/FullScreenLoader";
import { BankTransactionStatus } from "@interfaces/Esign";
import { CheckCircleOutlined } from "@mui/icons-material";
import { useVerifyBankTransferStatus } from "@hooks";
import { tracker } from "@utils/openreplay";

const StyledCheckCircleIcon = styled(CheckCircleOutlined)(({ theme }) => ({
  fontSize: "46px",
  color: theme.palette.success.main,
}));

export const SuccessfulBankTransferScreen: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const {
    data: challengeStatusData,
    isPending: isGettingTransactionStatus,
    error: errorGettingTransactionStatus,
  } = useVerifyBankTransferStatus();

  const onClickNext = useCallback(() => {
    const requestId = searchParams.get("requestId");
    const queryParams = requestId ? `?requestId=${requestId}` : "";
    navigate(
      `/app/registro/firma-electronica-avanzada/crear-pin${queryParams}`
    );
  }, [navigate, searchParams]);

  useEffect(() => {
    if (
      challengeStatusData?.challengeStatus === BankTransactionStatus.APPROVED
    ) {
      tracker?.event("BankTransferChallengeSuccess", {
        source: "SuccessfulBankTransferScreen",
      });
    }
  }, [challengeStatusData?.challengeStatus]);

  useEffect(() => {
    if (errorGettingTransactionStatus) {
      tracker?.event("BankTransferChallengeStatusError", {
        source: "SuccessfulBankTransferScreen",
        error: errorGettingTransactionStatus,
        errorMessage: errorGettingTransactionStatus?.message,
      });
    }
  }, [errorGettingTransactionStatus]);

  if (
    isGettingTransactionStatus ||
    challengeStatusData?.challengeStatus === BankTransactionStatus.PENDING
  )
    return (
      <>
        <FormHeader useMekiDocIcon />
        <FormContentContainer>
          <FormBody justifyContent="center">
            <FullScreenLoader title="Validando transferencia bancaria" />
          </FormBody>
        </FormContentContainer>
      </>
    );

  return (
    <>
      <FormHeader useMekiDocIcon />
      <FormContentContainer>
        <FormBody justifyContent="center">
          <Box
            marginBottom="48px"
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap="16px"
          >
            <StyledCheckCircleIcon />
            <Typography variant="h6" fontWeight="semibold">
              Transferencia exitosa
            </Typography>
          </Box>
          <BottomActionArea>
            <BottomActionButton onClick={onClickNext}>
              Continuar
            </BottomActionButton>
          </BottomActionArea>
        </FormBody>
      </FormContentContainer>
    </>
  );
};
